(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_popup"] && !Shopify.designMode) return;
  try {
    

   
    //   if($('.sssss_popup').hasClass('activee')){
    //  $('.collection_popup').show();
    //  $('.popup_collection_overlay').css("opacity", "1");
    // $("body").css("overflow", "hidden");
   
    //   $(document).on('click', '.popup_main_wrapper svg ,.popup_collection_overlay', function(){
    //    $('.popup_collection_overlay').css("opacity", "0");
    //     $('.popup_collection_overlay').css("z-index", "0");
    //      $("body").css("overflow", "visible");
    //      $('.collection_popup').hide();
    //   });
    //   }

               
//    $(document).ready(function(){
   
    
//       $(this).closest(".popup_collection_overlay").addClass("hide_popup_section");
//        // $.cookie('jqcookie', 'verificationpopup', { expires: 7 });
  
//      $(".popup_collection_overlay").on('click', function(){   
//        $('.popup_main_wrapper svg').trigger('click');
//     });
   
//     // var main_page = $.cookie('jqcookie');
//     // if(main_page == 'verificationpopup'){
//     //     $('.popup_collection_overlay').hide();
//     // }else{
//     //    setTimeout(function() {
//     //      $('.popup_collection_overlay').show();   
//     //       $('.popup_collection_overlay').css("opacity", "1");
//     //   }, 2500);
//     // }
     
// });

//  // $(document).on('click', 'button.show_hide_popup_button', function(){
//  //    $('.popup_collection_overlay').show();
//  //   $('.popup_collection_overlay').css("opacity", "1");
//  // });
//  //  $(document).on('click', '.popup_main_wrapper svg', function(){
//  //    $('.popup_collection_overlay').hide();
//  // });


  } catch(e) { console.error(e); }
})();
})();
